import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
	IconButton,
	InputAdornment,
	TextField,
	TextFieldProps
} from '@mui/material';
import { useToast } from 'hooks';
import React, { useCallback, useMemo } from 'react';
import { ToastSeverity } from 'types/toast';
import { useCopyToClipboard } from 'usehooks-ts';

interface ITextFieldValidation {
	id: string;
	formik: any;
	copy?: boolean;
	externalValue?: boolean;
}

const TextFieldValidation: React.FC<ITextFieldValidation & TextFieldProps> = ({
	id,
	formik,
	copy,
	externalValue,
	...props
}) => {
	const { addToast } = useToast();
	const textFieldProps = useMemo(() => props || {}, [props]);
	const [, copyFn] = useCopyToClipboard();

	const copyFunc = useCallback(async () => {
		const copied = await copyFn(
			externalValue ? textFieldProps.value : formik.values[id] || ''
		);
		if (copied) {
			addToast({
				severity: ToastSeverity.Success,
				content: intl.tr('toast.value.copied.to.clipboard')
			});
		}
	}, [copyFn, formik, addToast, id, textFieldProps, externalValue]);

	if (copy) {
		textFieldProps.InputProps = textFieldProps.InputProps || {};
		(textFieldProps.InputProps || {}).endAdornment = (
			<InputAdornment position="end">
				<IconButton
					aria-label={intl.tr('button.copy')}
					title={intl.tr('button.copy')}
					edge="end"
					onClick={copyFunc}
				>
					<ContentCopyIcon />
				</IconButton>
			</InputAdornment>
		);
	}

	return (
		<TextField
			{...textFieldProps}
			id={id}
			name={id}
			onBlur={formik.handleBlur}
			value={externalValue ? textFieldProps.value : formik.values[id]}
			onChange={formik.handleChange}
			error={formik.dirty && formik.touched[id] && Boolean(formik.errors[id])}
			helperText={formik.dirty && formik.touched[id] && formik.errors[id]}
			maxRows={!textFieldProps.rows ? 1 : undefined}
		/>
	);
};

TextFieldValidation.defaultProps = {
	copy: false,
	externalValue: false
};

export default TextFieldValidation;
